export const regexpLinkedin =
  /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[\w\d-]+\/?$/;
